import { GoogleReCaptchaProvider } from '@google-recaptcha/react';
import { PrimeReactProvider } from 'primereact/api';
import { BrowserRouter } from 'react-router-dom';

import DialogManager from './components/dialog-manager/DialogManager';
import SidebarManager from './components/sidebar-manager/SidebarManager';
import { DialogProvider } from './contexts/dialog/DialogProvider';
import NotificationProvider from './contexts/notification/NotificationProvider';
import { SidebarProvider } from './contexts/slidebar/SidebarProvider';
import WebsocketProvider from './contexts/websocket/WebsocketProvider';
import { AppRouter } from './routes';

// Fix for iPhone viewport scaling issue
if (navigator.userAgent.indexOf('iPhone') > -1) {
  document
    ?.querySelector('[name=viewport]')
    ?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
}

function App(): React.ReactElement {
  return (
    <GoogleReCaptchaProvider
      type='v2-checkbox'
      siteKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
    >
      <NotificationProvider>
        <PrimeReactProvider value={{ ripple: true }}>
          <WebsocketProvider>
            <BrowserRouter>
              <DialogProvider>
                <DialogManager />
                <SidebarProvider>
                  <SidebarManager />
                  <AppRouter />
                </SidebarProvider>
              </DialogProvider>
            </BrowserRouter>
          </WebsocketProvider>
        </PrimeReactProvider>
      </NotificationProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
